/* eslint-disable prettier/prettier */
const staticConfig = {
  tileServer: {
    url: "https://cyberjapandata.gsi.go.jp"
  }
};

const cognitoConfig = {
  Region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_ORa286oxV",
  ClientId: "3t9sudt2rjc9kegfppldb68je8"
};

export { staticConfig, cognitoConfig };
